// Author Liang Gang Qiang
// Date 2021-11-16 16:17:09

class SithMesInventoryOutdoorProductCategory {
constructor({
        id = null,
        code = '',
        name = '',
        tag = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.tag = tag;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryOutdoorProductCategory();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductCategory.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductCategory.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductCategory.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    nameFilter : '',
    tagFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductCategory.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductCategory.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductCategory.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesInventoryOutdoorProductCategory, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
